import { render, staticRenderFns } from "./yaslandirmaicmali.vue?vue&type=template&id=a836ea80&scoped=true"
import script from "./yaslandirmaicmali.vue?vue&type=script&lang=js"
export * from "./yaslandirmaicmali.vue?vue&type=script&lang=js"
import style0 from "./yaslandirmaicmali.vue?vue&type=style&index=0&id=a836ea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a836ea80",
  null
  
)

export default component.exports